import { createContext, useContext, useEffect, useState } from 'react';

export const EMAIL = 'support@nofina.id';

const id = {
  nav: {
    beranda: 'Beranda',
    tentang: 'Tentang',
    layanan: 'Layanan',
    kontak: 'Kontak',
  },
  ctaContact: 'Hubungi Kami',
  hero: {
    eyebrow: 'IDEA × EXECUTION × REAL IMPACT',
    lines: [
      [{ t: 'Membangun Ide' }],
      [{ t: 'Menjadi Sesuatu' }],
      [{ t: 'yang ' }, { t: 'Bernilai.', a: true }],
    ],
    sub: 'NOFINA adalah perusahaan Indonesia yang berfokus pada pengembangan produk, perdagangan, layanan kreatif, dan peluang digital untuk menciptakan nilai nyata bagi pasar dan masyarakat.',
    ctaPrimary: { label: 'Tentang Nofina', href: '#tentang' },
    ctaSecondary: { label: 'Lihat Layanan Kami', href: '#layanan' },
    wordmark: 'NOFINA',
    words: ['IDEAS', 'PRODUCTS', 'PEOPLE', 'GROWTH'],
    artAlt:
      'Abstrak visual premium NOFINA: pita merah mengkilap dan krom di atas permukaan hitam',
  },
  about: {
    eyebrow: 'TENTANG NOFINA',
    titleA: 'Satu Identitas.',
    titleB: 'Banyak Peluang',
    text: 'NOFINA terus mengembangkan berbagai peluang di bidang produk, perdagangan, layanan kreatif, dan solusi digital dengan pendekatan yang praktis, adaptif, dan berorientasi pada pertumbuhan jangka panjang.',
    legalLine: 'NOFINA merupakan brand yang dikelola oleh CV. MULTI ANUGERAH NUSANTARA.',
    cta: 'Pelajari Lebih Lanjut',
    href: '#layanan',
    visualAlt: 'Dinding gelap premium dengan pencahayaan merah dan logo NOFINA',
    points: [
      { icon: 'lightbulb', text: 'Berorientasi pada solusi nyata' },
      { icon: 'chart', text: 'Fokus pada pertumbuhan berkelanjutan' },
      { icon: 'users', text: 'Terbuka untuk kolaborasi dan peluang' },
      { icon: 'globe', text: 'Berbasis di Indonesia dengan visi yang luas' },
    ],
  },
  services: {
    eyebrow: 'LAYANAN UTAMA',
    titleA: 'Dua Fokus',
    titleB: 'yang Memberi Dampak',
    intro:
      'Kami mengembangkan layanan yang relevan, praktis, dan dapat memberikan nilai nyata.',
    items: [
      {
        id: 'ads',
        name: 'NOFINA',
        accent: 'ADS',
        subtitle: 'Video & Creative Production',
        desc: 'Layanan produksi video, konten kreatif, dan materi visual untuk membantu kebutuhan promosi, brand, dan komunikasi bisnis.',
        image: '/images/service-ads.jpg',
        alt: 'Kamera sinema profesional dalam studio gelap dengan cahaya merah',
      },
      {
        id: 'shop',
        name: 'NOFINA',
        accent: 'SHOP',
        subtitle: 'Penjualan Online',
        desc: 'Aktivitas perdagangan online NOFINA yang menghadirkan berbagai produk pilihan melalui kanal digital dan marketplace.',
        image: '/images/service-shop.jpg',
        alt: 'Kantong belanja premium merah dan hitam di atas permukaan gelap',
      },
    ],
  },
  principles: {
    eyebrow: 'PRINSIP KAMI',
    titleA: 'Cara Kami',
    titleB: 'Bertumbuh',
    intro:
      'Setiap langkah yang kami lakukan didasarkan pada prinsip yang jelas dan konsisten.',
    items: [
      {
        id: 'practical',
        icon: 'cog',
        title: 'Practical',
        desc: 'Kami membangun sesuatu yang memiliki kegunaan nyata bagi pasar dan masyarakat.',
      },
      {
        id: 'creative',
        icon: 'lightbulb',
        title: 'Creative',
        desc: 'Kami mencari cara yang lebih baik untuk menghadirkan ide, produk, dan komunikasi.',
      },
      {
        id: 'adaptive',
        icon: 'chart',
        title: 'Adaptive',
        desc: 'Kami terus berkembang mengikuti perubahan pasar dan teknologi.',
      },
      {
        id: 'growth',
        icon: 'users',
        title: 'Built for Growth',
        desc: 'Setiap inisiatif dirancang untuk dapat berkembang secara berkelanjutan.',
      },
    ],
  },
  contact: {
    titleA: 'Mari Terhubung',
    titleB: 'dengan NOFINA',
    text: 'Untuk pertanyaan bisnis, kolaborasi, layanan, atau informasi lebih lanjut, hubungi tim NOFINA.',
    cta: 'Hubungi Kami',
  },
  footer: {
    line: 'Ideas. Products. People. Growth.',
    navTitle: 'Nofina',
    contactTitle: 'Kontak',
    langTitle: 'Bahasa',
    rights: '© 2026 CV. MULTI ANUGERAH NUSANTARA · NOFINA. All rights reserved.',
  },
};

const en = {
  nav: {
    beranda: 'Home',
    tentang: 'About',
    layanan: 'Services',
    kontak: 'Contact',
  },
  ctaContact: 'Contact Us',
  hero: {
    eyebrow: 'IDEA × EXECUTION × REAL IMPACT',
    lines: [
      [{ t: 'Turning Ideas' }],
      [{ t: 'into Something' }],
      [{ t: 'Valuable.', a: true }],
    ],
    sub: 'NOFINA is an Indonesian company focused on product development, trade, creative services, and digital opportunities to create real value for the market and society.',
    ctaPrimary: { label: 'About Nofina', href: '#tentang' },
    ctaSecondary: { label: 'Explore Our Services', href: '#layanan' },
    wordmark: 'NOFINA',
    words: ['IDEAS', 'PRODUCTS', 'PEOPLE', 'GROWTH'],
    artAlt:
      'Premium NOFINA abstract visual: glossy red and chrome ribbons over black surfaces',
  },
  about: {
    eyebrow: 'ABOUT NOFINA',
    titleA: 'One Identity.',
    titleB: 'Many Opportunities',
    text: 'NOFINA continues to develop opportunities across products, trade, creative services, and digital solutions with a practical, adaptive, and long-term growth-oriented approach.',
    legalLine: 'NOFINA is a brand operated by CV. MULTI ANUGERAH NUSANTARA.',
    cta: 'Learn More',
    href: '#layanan',
    visualAlt: 'Premium dark wall with red lighting and the NOFINA logo',
    points: [
      { icon: 'lightbulb', text: 'Focused on real solutions' },
      { icon: 'chart', text: 'Committed to sustainable growth' },
      { icon: 'users', text: 'Open to collaboration and opportunities' },
      { icon: 'globe', text: 'Based in Indonesia with a broad vision' },
    ],
  },
  services: {
    eyebrow: 'OUR CORE SERVICES',
    titleA: 'Two Focuses',
    titleB: 'that Create Impact',
    intro:
      'We develop services that are relevant, practical, and able to deliver real value.',
    items: [
      {
        id: 'ads',
        name: 'NOFINA',
        accent: 'ADS',
        subtitle: 'Video & Creative Production',
        desc: 'Video production, creative content, and visual materials to support promotional, brand, and business communication needs.',
        image: '/images/service-ads.jpg',
        alt: 'Professional cinema camera in a dark studio with red lighting',
      },
      {
        id: 'shop',
        name: 'NOFINA',
        accent: 'SHOP',
        subtitle: 'Online Sales',
        desc: "NOFINA's online trading activity, offering a curated selection of products through digital channels and marketplaces.",
        image: '/images/service-shop.jpg',
        alt: 'Premium red and black shopping bags on a dark surface',
      },
    ],
  },
  principles: {
    eyebrow: 'OUR PRINCIPLES',
    titleA: 'How We',
    titleB: 'Grow',
    intro: 'Every step we take is grounded in clear and consistent principles.',
    items: [
      {
        id: 'practical',
        icon: 'cog',
        title: 'Practical',
        desc: 'We build things that have real use for the market and society.',
      },
      {
        id: 'creative',
        icon: 'lightbulb',
        title: 'Creative',
        desc: 'We look for better ways to present ideas, products, and communication.',
      },
      {
        id: 'adaptive',
        icon: 'chart',
        title: 'Adaptive',
        desc: 'We keep evolving with changes in the market and technology.',
      },
      {
        id: 'growth',
        icon: 'users',
        title: 'Built for Growth',
        desc: 'Every initiative is designed to grow sustainably.',
      },
    ],
  },
  contact: {
    titleA: 'Connect with',
    titleB: 'NOFINA',
    text: 'For business inquiries, collaboration, services, or further information, contact the NOFINA team.',
    cta: 'Contact Us',
  },
  footer: {
    line: 'Ideas. Products. People. Growth.',
    navTitle: 'Nofina',
    contactTitle: 'Contact',
    langTitle: 'Language',
    rights: '© 2026 CV. MULTI ANUGERAH NUSANTARA · NOFINA. All rights reserved.',
  },
};

export const content = { id, en };

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => {
    try {
      return localStorage.getItem('nofina-lang') === 'en' ? 'en' : 'id';
    } catch {
      return 'id';
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem('nofina-lang', lang);
    } catch {}
    document.documentElement.lang = lang === 'en' ? 'en' : 'id';
  }, [lang]);

  return (
    <LanguageContext.Provider
      value={{ lang, setLang, t: content[lang], isID: lang === 'id' }}
    >
      {children}
    </LanguageContext.Provider>
  );
}

export const useLanguage = () => useContext(LanguageContext);
